import { Consortium } from "../models/consortium/consortium";
import { ListParams } from "../models/listParams";
import { OrganisatiesWebService } from "../webservices/organisaties.web.service";
import { retryWithAuth } from "./utils/retryWithAuth";
import { BaseService } from "./base.service";

export class ConsortiumService extends BaseService {
  private static instance: ConsortiumService;

  private constructor() {
    super();
  }

  public static getInstance(): ConsortiumService {
    if (!ConsortiumService.instance) {
      ConsortiumService.instance = new ConsortiumService();
    }

    return ConsortiumService.instance;
  }

  public async getConsortiums(params: ListParams | null): Promise<any> {
    const webService = new OrganisatiesWebService();
    try {
      return await retryWithAuth(
        () => webService.getConsortiums(params),
        2,
        { redirectOnForbidden: false }
      );
    }
    catch (error: any) {
      if (this.isForbiddenError(error)) {
        console.warn('[ConsortiumService] 403 ontvangen voor de huidige rol bij GET /api/v1/consortiums; fallback naar lege lijst.');
        return {
          count: 0,
          offset: params?.offset ?? 0,
          limit: params?.limit ?? 0,
          items: [],
        };
      }

      throw error;
    }
  }

  public async getConsortium(consortiumId: string): Promise<Consortium> {
    const webService = new OrganisatiesWebService();
    return retryWithAuth<Consortium>(() => webService.getConsortium(consortiumId), 2);
  }

  public async createConsortium(consortium: Consortium): Promise<any> {
    const webService = new OrganisatiesWebService();
    return retryWithAuth(() => webService.createConsortium(consortium), 2);
  }

  public async updateConsortium(consortium: Consortium): Promise<any> {
    const webService = new OrganisatiesWebService();
    return retryWithAuth(() => webService.updateConsortium(consortium), 2);
  }

  public async deleteConsortium(consortiumId: string): Promise<any> {
    const webService = new OrganisatiesWebService();
    return retryWithAuth(() => webService.deleteConsortium(consortiumId), 2);
  }

  public async addOrganizationToConsortium(consortiumId: string, organizationId: string): Promise<any> {
    const webService = new OrganisatiesWebService();
    return retryWithAuth(() => webService.addOrganizationToConsortium(consortiumId, organizationId), 2);
  }

  public async removeOrganizationFromConsortium(consortiumId: string, organizationId: string): Promise<any> {
    const webService = new OrganisatiesWebService();
    return retryWithAuth(() => webService.removeOrganizationFromConsortium(consortiumId, organizationId), 2);
  }
}

export const consortiumService = ConsortiumService.getInstance();

